import SimInfoChangeInstallerModal from './sim-info-change-installer-modal.vue'
export default SimInfoChangeInstallerModal
